import { Component, inject } from '@angular/core';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-notifications-toast',
  standalone: true,
  template: `
    <div class="toast-container">
      @for (notif of notifService.notifications(); track notif.id) {
        <div class="toast toast--{{ notif.type }} animate-slide-right">
          <div class="toast__icon">
            @switch (notif.type) {
              @case ('success') { ✓ }
              @case ('error')   { ✕ }
              @case ('warning') { ⚠ }
              @default          { ℹ }
            }
          </div>
          <div class="toast__content">
            <div class="toast__title">{{ notif.title }}</div>
            @if (notif.message) {
              <div class="toast__message">{{ notif.message }}</div>
            }
          </div>
          <button class="toast__close" (click)="notifService.dismiss(notif.id)">✕</button>
        </div>
      }
    </div>
  `,
  styles: [`
    .toast-container {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: var(--z-modal);
      display: flex;
      flex-direction: column;
      gap: 10px;
      pointer-events: none;
    }

    .toast {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 12px 16px;
      border-radius: var(--radius-md);
      border: 1px solid var(--border-default);
      background: var(--bg-elevated);
      box-shadow: var(--shadow-lg);
      min-width: 300px;
      max-width: 420px;
      pointer-events: all;
    }

    .toast--success { border-color: var(--color-success); }
    .toast--error   { border-color: var(--color-error); }
    .toast--warning { border-color: var(--color-warning); }
    .toast--info    { border-color: var(--color-info); }

    .toast__icon {
      font-size: 0.875rem;
      font-weight: 700;
      flex-shrink: 0;
      margin-top: 1px;
    }

    .toast--success .toast__icon { color: var(--color-success); }
    .toast--error   .toast__icon { color: var(--color-error); }
    .toast--warning .toast__icon { color: var(--color-warning); }
    .toast--info    .toast__icon { color: var(--color-info); }

    .toast__content { flex: 1; min-width: 0; }

    .toast__title {
      font-size: 0.8125rem;
      font-weight: 600;
      color: var(--text-primary);
      line-height: 1.4;
    }

    .toast__message {
      font-size: 0.75rem;
      color: var(--text-secondary);
      margin-top: 2px;
      line-height: 1.4;
    }

    .toast__close {
      background: none;
      border: none;
      color: var(--text-tertiary);
      cursor: pointer;
      font-size: 0.7rem;
      padding: 2px;
      flex-shrink: 0;
      line-height: 1;
    }

    .toast__close:hover { color: var(--text-primary); }
  `],
})
export class NotificationsToastComponent {
  notifService = inject(NotificationService);
}
